import { inject } from "@angular/core";
import { CanActivateChildFn, CanActivateFn, Router } from "@angular/router";
import { FuseConfirmationService } from "@fuse/services/confirmation";
import { showNoPermission } from "app/_helpers/common-helpers";
import { AuthService } from "app/core/auth/auth.service";
import { UserService } from "app/core/user/user.service";
import { of, switchMap } from "rxjs";

export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
  const router: Router = inject(Router);
  const userService: UserService = inject(UserService);
  const fuseConfirmationService: FuseConfirmationService = inject(FuseConfirmationService);
  // Check the authentication status
  return inject(AuthService)
    .check()
    .pipe(
      switchMap(authenticated => {
        // If the user is not authenticated...
        if (!authenticated) {
          // Redirect to the sign-in page with a redirectUrl param
          const redirectURL = state.url === "/sign-out" ? "" : `redirectURL=${state.url}`;
          const urlTree = router.parseUrl(`sign-in?${redirectURL}`);

          return of(urlTree);
        }

        if (route?.data["permissions"] && !userService.isPermitted(route?.data["permissions"])) {
          // const redirectURL = state.url === '/sign-out' ? '' : `redirectURL=${state.url}`;
          // const urlTree = router.parseUrl(`sign-in?${redirectURL}`);
          showNoPermission(fuseConfirmationService, route?.data["page"]);
          return of(false);
        }

        // Allow the access
        return of(true);
      })
    );
};
